(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pf-footer-signup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-pf-signup-form]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    const formId = button.dataset.pfSignupForm;
    if (!['ReB2Sk', 'XcSHRT'].includes(formId)) return;
    const error = button.parentElement.querySelector('[data-pf-signup-error]');
    if (error) error.hidden = true;
    button.setAttribute('aria-busy', 'true');
    const timer = window.setTimeout(() => {
      button.removeAttribute('aria-busy');
      if (error) error.hidden = false;
    }, 8000);
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId, () => {
      window.clearTimeout(timer);
      button.removeAttribute('aria-busy');
      if (error) error.hidden = true;
    }]);
  });
  } catch(e) { console.error(e); }
})();

})();
